class AtShowMetaobjectSwatchList extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

onClick(event) {
    event.preventDefault();
    const container = this.parentElement;
    if (!container) return;
    container.querySelectorAll('.at-custom-metaobject-swatch--hidden').forEach((el) => el.classList.toggle('visually-hidden'));
    this.querySelector('svg')?.classList.toggle('at-rotate');
  }
}

customElements.define('at-show-metaobject-swatch-list', AtShowMetaobjectSwatchList);
